var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chip",class:{
    'size-small': _vm.size === 'small' && !_vm.bold && !_vm.italic,
    'size-small-bold': _vm.size === 'small' && _vm.bold,
    'size-small-italic': _vm.size === 'small' && _vm.italic,
    'size-medium': _vm.size === 'medium',
    'size-medium-bold': _vm.size === 'medium' && _vm.bold,
    'size-medium-italic': _vm.size === 'medium' && _vm.italic,
    'background-light': _vm.background === 'light',
    'background-solid': _vm.background === 'solid',
    'background-transparent': _vm.background === 'transparent',
    'type-default': _vm.type === 'default',
    'type-primary': _vm.type === 'primary',
    'type-secondary': _vm.type === 'secondary',
    'type-light': _vm.type === 'light',
    'type-warning': _vm.type === 'warning',
    'type-error': _vm.type === 'error',
  }},[(_vm.dot)?_c('div',{staticClass:"chip__dot"}):_vm._e(),_vm._v(" "),(_vm.iconLeft)?_c('SvgIcon',{staticClass:"chip__icon",attrs:{"name":_vm.iconLeft}}):(_vm.iconUrl)?_c('img',{staticClass:"chip__icon",attrs:{"src":_vm.iconUrl,"alt":"icon"}}):_vm._e(),_vm._v(" "),_c('UiText',{staticClass:"chip__text",attrs:{"font":_vm.c_fontType,"text":_vm.text}},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],2),_vm._v(" "),(_vm.iconRight)?_c('SvgIcon',{staticClass:"chip__icon",attrs:{"name":_vm.iconRight}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }